module.exports = __webpack_public_path__ + "img/pcba_02.2c9abbb9.png";